import React, { FC } from 'react';

import CheckboxListItem from '../../../CheckboxListItem';

import { SearchDataItem } from '../types';

import { getBadgeColor, getLabel, getUserData } from './helpers';

export type Props = {
  isSelected?: boolean;
  item: SearchDataItem;
  onChange?: (itemId: SearchDataItem['id'], state: boolean) => void;
};

/**
 * A single row in the items list within search results
 *
 * @param props            Props passed to the component
 * @param props.isSelected Whether the item is already selected
 * @param props.item       Group, member or label data
 * @param props.onChange   When the checkbox is toggled
 * @returns                The component itself
 */
const SearchListItem: FC<Props> = ({
  isSelected = false,
  item,
  onChange = null,
}) => {
  const badgeColor = getBadgeColor(item);
  const label = getLabel(item);
  const user = getUserData(item);

  /**
   * Handle change of the item state
   *
   * @param state State to be set
   */
  const handleChange = (state: boolean) => {
    if (onChange !== null) {
      onChange(item.id, state);
    }
  };

  return (
    <CheckboxListItem
      badgeColor={badgeColor}
      isChecked={isSelected}
      label={label}
      onChange={handleChange}
      user={user}
    />
  );
};

export default SearchListItem;
